import React from 'react';

const activities = [
  {
    image: '/activity-01.jpeg',
    title: 'Cultural Events',
    description: 'Students participate in vibrant cultural programs celebrating diversity and talent.'
  },
  {
    image: '/activity-02.jpeg',
    title: 'Sports Activities',
    description: 'Encouraging physical fitness and team spirit through various sports events.'
  },
  {
    image: '/activity-03.jpeg',
    title: 'Annual Day Celebration',
    description: 'Grand annual celebrations showcasing student achievements and performances.'
  },
  {
    image: '/activity-05.jpeg',
    title: 'Educational Workshops',
    description: 'Regular workshops and seminars to enhance teaching skills and knowledge.'
  },
  {
    image: '/activity-06.jpeg',
    title: 'Community Outreach',
    description: 'Students engage in social service and community development initiatives.'
  },
  {
    image: '/activity-07.jpeg',
    title: 'Academic Excellence',
    description: 'Fostering academic growth through innovative teaching methodologies.'
  }
];

function Activities() {
  return (
    <section className="activities-section" id="activities">
      <div className="section-title">
        <h2>Our Activities</h2>
      </div>
      <div className="activities-grid">
        {activities.map((activity, index) => (
          <div className="activity-card" key={index}>
            <img src={activity.image} alt={activity.title} />
            <div className="activity-card-content">
              <h4>{activity.title}</h4>
              <p>{activity.description}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Activities;
